import React, { useContext, useEffect,useState } from "react";
import konsole from "../../network/konsole";
import "./Seminar.css";
import { StpperStepsContext } from "./SeminarFile";
import { Router, useNavigate } from "react-router-dom";
import Stepper from "./Stepper";
import commonLib from "../../control/commonLib";
import { isNullUndefine } from "../../control/Constant";
const Preview = ({
  text,
  sendDataToPrev,
  form,
  callFunction,
  getAllIdBack,
  sendToPreview,
  setStopEditFunc,
  stopEditFunc,
  editFuncData,
  stopSpeakerEditFunc,
  setStopSpeakerEditFunc,
  setStopFareEditFunc,
  stopFareEditFunc,
  CallFunction,
  multiSpeakersData,
}) => {
  let navigate = useNavigate();

  const { setStepperSteps, setsendToPreview, venueAddressIdTextPublish } = useContext(StpperStepsContext);
  const [readMoreProfile, setReadMoreProfile] = useState(null)
  const [showLess, setShowLess] = useState(false)

  konsole.log("sendToPreviewsendToPreview", sendToPreview,multiSpeakersData);

  useEffect(() => {
    konsole.log("sendToPreviewsendToPreview", sendToPreview);
    if (sendToPreview == "1") {
      reverseClick();
    }
  }, [sendToPreview]);

  let getSeminarFilesDetails = JSON.parse(sendDataToPrev);
  console.log("MyPropss", getSeminarFilesDetails);

  const FixedResult = {
    seminarType: getSeminarFilesDetails.seminarType,
    topics: getSeminarFilesDetails.seminar.topics,
    seminarData: getSeminarFilesDetails.seminar.seminarData,
    seminartime: getSeminarFilesDetails.seminar.seminarTime,
    seminarSeatsNo: getSeminarFilesDetails.seminar.noOfSeats,
    seminarVenue: getSeminarFilesDetails.seminar.seminarVenue,
    seminarMapLink: getSeminarFilesDetails.seminar.mapLink,
    seminarVideoLink: getSeminarFilesDetails.seminar.videoLink,
    seminarDescription: getSeminarFilesDetails.seminar.description,
    seminarSpeakerimg: getSeminarFilesDetails.seminar.speaker.speakerImage,
    seminarSpeakerName: getSeminarFilesDetails.seminar.speaker.speakerName,
    seminarVideoLink: getSeminarFilesDetails.seminar.speaker.speakerVideoLink,
    seminarSpeakerDescription:
      getSeminarFilesDetails.seminar.speaker.speakerDescription,
    seminarOrgPartner:
      getSeminarFilesDetails.seminar.organizerInformation
        .seminarOrganizingPartner,
    seminarCoordinatorName:
      getSeminarFilesDetails.seminar.coordinator.coordinatorName,
    seminarCoordinatorContact:
      getSeminarFilesDetails.seminar.coordinator.coordinatorContact,
    seminarcoordinatorEmail:
      getSeminarFilesDetails.seminar.coordinator.coordinatorEmail,
    seminarFare: getSeminarFilesDetails.seminar.seminarFare.isSeminarPaid,
    seminarLocation: getSeminarFilesDetails.seminar.venueLocation,
    seminarVenueAddress: getSeminarFilesDetails.seminar.venueAddressIdApi,
    seminarSpeakerId: getSeminarFilesDetails.seminar.speakerId,
    seminarCoordinatorId: getSeminarFilesDetails.seminar.coordinatorId,
    seminarVenueName: getSeminarFilesDetails.seminar.seminarVenueName,
    seminarSubtenantId: getSeminarFilesDetails.seminar.subtenantId,
    seminarFixedPrice: getSeminarFilesDetails.seminar.seminarFare.fareAmount,
  };

  let ChangeDateData = commonLib.getFormattedDate(FixedResult.seminarData);
let splitTime = FixedResult.seminartime.split("")
let split12HourFormat = splitTime.splice(splitTime.length - 2, 2).join("")

  konsole.log("ChangeDateData", ChangeDateData);
  konsole.log("FixedResult.seminartimeFixedResult.seminartimeF",FixedResult.seminartime,FixedResult );
  konsole.log("FixedResult.seminartimeFixedResult.seminartime",splitTime.splice(splitTime.length - 2, 2).join("") );
  konsole.log("FixedResult.seminartimeFixedResult.seminartime",split12HourFormat );
  const reverseClick = () => {
    text(0);
    setStepperSteps(0);

    getAllIdBack({
      getSpeakerId: FixedResult.seminarSpeakerId,
      getCoordinatorID: FixedResult.seminarCoordinatorId,
      getVenvueName: FixedResult.seminarVenueName,
      getSubtenantID: FixedResult.seminarSubtenantId,
      getFixedPrice: FixedResult.seminarFixedPrice,
      getFreePaidStatus: FixedResult.seminarFare,
      getImgUrl: FixedResult.seminarSpeakerimg,
      backButton : true,
    });
    setsendToPreview("2");

    if (
      editFuncData !== null &&
      editFuncData !== undefined &&
      editFuncData !== ""
    ) {
      if (stopEditFunc == true) {
        setStopEditFunc(true);
      } else {
        setStopEditFunc(false);
      }

      if (stopSpeakerEditFunc == true) {
        setStopSpeakerEditFunc(true);
      } else {
        setStopSpeakerEditFunc(false);
      }

      if (stopFareEditFunc == true) {
        setStopFareEditFunc(true);
      } else {
        setStopFareEditFunc(false);
      }
    }
  };
  const metaPage = () => {
    form.submit(() => callFunction());
    CallFunction(venueAddressIdTextPublish)

    // text(2);
    setStepperSteps(2);
  };

  const filterSpeakerDescriptionLegth = (dataSpeakerProfile) => {
      return dataSpeakerProfile?.substr(0, 50) || "";
  };

  const showFullProfile=(items,index)=>{
    setReadMoreProfile(items?.speakerUserId)
    let setAtZero = [];
    let filterData = [];
    filterData = multiSpeakersData.splice(index, 1);
    setAtZero = multiSpeakersData.unshift(items);
    setShowLess(true)
    }

  console.log("editFuncDataPreviouse", FixedResult.seminarSpeakerName);

  return (
    <>
      <div className="container-fluid">
        <div>
          {/* <p className="ms-2 fs-4 fw-bold seminartxt">Preview</p> */}
          <div style={{ border: "2px solid #F0F0F0", borderRadius: "6px", marginBottom: "24px", overflow: "hidden" }}>

            {/* ── Header ── */}
            <div style={{ background: "linear-gradient(to right, #4A0311, #AA223A)", padding: "14px 18px" }}>
           <div className="d-flex justify-content-between align-items-start">
             <div>
             <h3 style={{ color: "#fff", marginBottom: 0, fontWeight: 700, fontSize: "20px" }}>
               {FixedResult.topics}
             </h3>
             <div style={{ color: "#fff", fontSize: "14px", marginTop: 4 }}>
               By {multiSpeakersData?.map((ele, index) => {
                    return `${ele?.speakerName == undefined || ele?.speakerName == null || ele?.speakerName == "" ? ele?.fName + " " + ele?.lName : ele?.speakerName}${(multiSpeakersData?.length - 1 == index) ? "" : ', '}`
                   })}
              </div>
             </div>
             <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0 }}>
              <div className="d-flex flex-column align-items-center">
              <label style={{ fontSize: "13px", color: "#fff", marginBottom: "4px" }}>Seminar Type</label>
                    <span style={{ border: "2px solid #D9D9D9", borderRadius: "20px", color: "#720C20", padding: "1px 14px", fontSize: "13px", backgroundColor: "#FFF0F0" }}>
                      {FixedResult.seminarType}
                    </span>
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <label style={{ fontSize: "13px", color: "#fff", marginBottom: "4px" }}>Seminar Fare</label>
                    <span style={{ border: "2px solid #D9D9D9", borderRadius: "20px", color: "#720C20", padding: "1px 14px", fontSize: "13px", backgroundColor: "#FFF0F0" }}>
                      {FixedResult.seminarFare}{FixedResult.seminarFare == "Paid" && FixedResult.seminarFixedPrice ? ` : $${FixedResult.seminarFixedPrice}` : ""}
                    </span>
                  </div>
              </div>
              </div>
             </div>

           <div style={{ borderBottom: "1px solid #dee2e6", padding: "12px 20px", backgroundColor: "#fff" }}>
           <div className="d-flex justify-content-between" style={{ gap: "32px", flexWrap: "wrap" }}>
                {/* Date */}
            <div className="d-flex align-items-start gap-2">
            <img src="/images/Frame101.svg" alt="date" style={{ width: 28, marginTop: 2, flexShrink: 0 }} />
            <div>
                    <div style={{ fontSize: "13px", color: "#555", fontWeight: 600 }}>Date</div>
              <div style={{ fontSize: "14px", color: "#222" }}>
                      {split12HourFormat == "pm" || split12HourFormat == "am"
                        ? `${ChangeDateData}, at ${FixedResult.seminartime}`
                        : `${ChangeDateData}, at ${commonLib.getFormattedTime(FixedResult.seminartime)}`}
            </div>
            </div>
                </div>

                {FixedResult?.seminarType !== "Webinar" && FixedResult?.seminarVenue && (
                  <div className="d-flex align-items-start gap-2">
                    <img src="/images/Frame102.svg" alt="venue" style={{ width: 28, marginTop: 2, flexShrink: 0 }} />
                    <div>
                      <div style={{ fontSize: "13px", color: "#555", fontWeight: 600 }}>Venue</div>
                      <div style={{ fontSize: "14px", color: "#222" }}>{FixedResult?.seminarVenue}</div>
                    </div>
           </div>
                )}

                {/* Location */}
                {FixedResult?.seminarType !== "Webinar" && FixedResult?.seminarLocation && (
           <div className="d-flex align-items-start gap-2">
                    <img src="/images/Frame102.svg" alt="location" style={{ width: 28, marginTop: 2, flexShrink: 0 }} />
                    <div>
                      <div style={{ fontSize: "13px", color: "#555", fontWeight: 600 }}>Location</div>
                      <div style={{ fontSize: "14px", color: "#222" }}>{FixedResult?.seminarLocation}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>


            <div style={{ padding: "14px 18px", backgroundColor: "#fff" }}>

              {/* About Seminar */}
              <div style={{ borderBottom: "1px solid #dee2e6", paddingBottom: 12, marginBottom: 8 }}>
                <div style={{ fontWeight: 700, fontSize: "15px", marginBottom: 4 }}>About Seminar</div>
                <p style={{ fontSize: "14px", marginBottom: 0, wordBreak: "break-word" }}>{FixedResult.seminarDescription}</p>
              </div>

              {/* Speakers */}
              <div style={{ paddingBottom: 12, marginBottom: 10 }}>
                <div style={{ fontWeight: 700, fontSize: "15px", marginBottom: 10 }}>
                  {multiSpeakersData?.length > 1 ? "Speakers" : "Speaker"}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "flex-start" }}>
                  {multiSpeakersData.map((items, ind) => {
                    const isExpanded = (readMoreProfile == items?.speakerUserId) && showLess == true;
                    const hasLongProfile = items?.speakerProfile?.length > 150;
                    return (
                      <div
                        key={ind}
                        style={{
                          border: "2px dashed #720C20",
                          borderRadius: "8px",
                          padding: "16px 12px",
                          width: isExpanded ? "100%" : "240px",
                          height: isExpanded ? "auto" : "210px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          textAlign: "center",
                          boxSizing: "border-box",
                          overflow: "hidden"
                        }}
                      >
                        {/* Profile Image */}
                          <img
                            src={
                              !isNullUndefine(items?.speakerUrl)
                                ? items?.speakerUrl
                                : "/images/profileDummy.svg"
                            }
                            alt=""
                          style={{
                            width: "72px",
                            height: "72px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginBottom: "10px",
                            backgroundColor: "#e0e0e0",
                            flexShrink: 0
                          }}
                        />
                        {/* Name */}
                        <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "8px", flexShrink: 0 }}>
                          {items?.speakerName || `${items?.fName || ""} ${items?.lName || ""}`.trim()}
                        </div>
                        {/* Description */}
                        {items?.speakerProfile && (
                          <div style={{
                            fontSize: "13px",
                            color: "#444",
                            textAlign: isExpanded ? "left" : "center",
                            marginBottom: "6px",
                            flex: 1
                          }}>
                            {isExpanded
                              ? items?.speakerProfile
                              : hasLongProfile
                                ? `${items?.speakerProfile?.substr(0, 50)}...`
                                : items?.speakerProfile
                            }
                        </div>
                        )}
                        {/* Read More / Show Less */}
                        {isExpanded ? (
                          <a
                            onClick={() => setShowLess(false)}
                            style={{ color: "#720C20", fontWeight: 600, cursor: "pointer", fontSize: "13px", textDecoration: "none", flexShrink: 0 }}
                          >
                            Show Less
                          </a>
                        ) : hasLongProfile ? (
                          <a
                            onClick={() => showFullProfile(items, ind)}
                            style={{ color: "#720C20", fontWeight: 600, cursor: "pointer", fontSize: "13px", textDecoration: "none", flexShrink: 0 }}
                          >
                            Read More
                          </a>
                        ) : null}
                      </div>
                       )
                      })}
           </div>
            </div>
           </div>
          </div>
        </div>

        <div className="d-flex justify-content-between pb-5">
          <div>
            <button
              className="seminarbtn mt-3 ms-3 text-white"
              onClick={reverseClick}
            >
              Back
            </button>
          </div>
          <div>
            <button
              className="seminarbtn mt-3 me-3 text-white"
              onClick={metaPage}
            >
              {/* Next */}
              Publish
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Preview;
